import React from 'react'
import { Typography, Modal, Button, Icon, Row, Col } from 'antd'

const { Text, Title } = Typography
class ImageFile extends React.PureComponent {

	async componentDidMount() {
    }

	render() {
		const { typeFile, file } = this.props
		return (
			<>
            <img style={{ width: '100%' }} src={'data:'+typeFile+';base64,'+file} className="zoom-in"></img><br></br><br></br>
				{/* <a href={'data:'+typeFile+';base64,'+file} className="mt-3 btn-color-default btn-custom color-white px-4 py-2 " download>ดาวน์โหลดรูปภาพ</a> */}
			</>
		)
	}
}

export default ImageFile